<div class="spin spin-1 branding-accent-normal-background"></div>
<div class="spin spin-2 branding-accent-normal-background"></div>
<div class="spin spin-3 branding-accent-normal-background"></div>
<div class="spin spin-4 branding-accent-normal-background"></div>
<div class="spin spin-5 branding-accent-normal-background"></div>
<div class="spin spin-6 branding-accent-normal-background"></div>
<div class="spin spin-7 branding-accent-normal-background"></div>
<div class="spin spin-8 branding-accent-normal-background"></div>
